export default __webpack_public_path__ + "static/media/5.d08f39bb.webp";